export const BASE_URL =
  "https://cors-anywhere.herokuapp.com/https://wexapis-uks-uat-apim.azure-api.net/";

// هنا نحدد الـ URLs أو الـ endpoints اللي ما يحتاجوا Authorization
const AUTH_EXCEPTIONS = [
  "/SendVcodeFromWebSite",   // sendDeleteAccountOtp
  "/VerifyOtpAndDeleteUser", // verifyOtpAndDeleteUser
];

// interceptor للطلبات اللي تحتاج Authorization
const onAuthRequest = (config) => {
  // إذا هذا الرابط موجود في الاستثناءات، رجع config بدون Authorization
  if (AUTH_EXCEPTIONS.some((url) => config.url.includes(url))) {
    return config;
  }

  const token =
    localStorage.getItem("profile") || sessionStorage.getItem("profile");
  const access_token = JSON.parse(token)?.accessToken;

  if (access_token) {
    config.headers["Authorization"] = "Bearer " + access_token;
  } else {
    // لو ما فيه توكن، نعمل reload للصفحة
    window.location.reload();
  }

  return config;
};

// interceptor للطلبات العادية بدون reload
const onRequest = (config) => {
  if (AUTH_EXCEPTIONS.some((url) => config.url.includes(url))) {
    return config;
  }

  const token =
    localStorage.getItem("profile") || sessionStorage.getItem("profile");
  const access_token = JSON.parse(token)?.accessToken;

  if (access_token) {
    config.headers["Authorization"] = "Bearer " + access_token;
  }

  return config;
};

// أخطاء الطلب
const onRequestError = (error) => {
  console.error(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

// الاستجابة
const onResponse = (response) => {
  return response;
};

const onResponseError = (error) => {
  console.error(`[response error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

// interceptors مع Authorization
export function setupInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(onAuthRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}

// interceptors عادية (مثلاً common requests)
export function setupCommonInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
